export enum AppRoute {
  /* The app is mounted at VITE_APP_PATH (/register) via the router basename, so the landing page is the root of that mount — NOT `/register` again (which would resolve to /register/register`) */
  LANDING = '/',
  MAINTENANCE = '/maintenance',
  APPLIANCE_DETAILS = '/appliance-details',
  MODEL_SERIAL = '/model-serial',
  PURCHASE_PRICE = '/purchase-price',
  ARRIVAL_DATE = '/arrival-date',
  PERSONAL_DETAILS = '/personal-details',
  QUOTE = '/quote',
  CHECKOUT = '/checkout',
  CONFIRMATION = '/confirmation',
  ERROR = '/error',
}
